export default {"src":"/_next/static/media/weekly_schedule_icon.8273e7ed.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};